import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAPI } from "../../service/http-service";
import { CommonEndpoint } from "../../service/endpointConfig/CommonEndpoint";

let initialState: any = {
  schoolResponse: {},
};

//Get School API call
export const SchoolService = createAsyncThunk(
  "master/school",
  async (school: any) => {
    try {
      return await getAPI(CommonEndpoint.school);
    } catch (err) {
      return err;
    }
  }
);

const schoolSlice = createSlice({
  name: "school",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      SchoolService.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.status = action.payload?.status;
        state.error = "";
        state.data = action.payload?.data?.data;
      }
    );
    builder.addCase(SchoolService.rejected, (state, action) => {
      state.loading = false;
      state.status = -1;
      state.error = action.error.message || "Something went wrong";
      state.data = {};
    });
  },
});

const schoolReducer = schoolSlice.reducer;
export default schoolReducer;
